import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class NewactionService {
  token:any;

  //Retrieve actions statistics
  pathApiStatisctics:string="/v1/actions/statistics";
  urlRequestStatisctics: string =urlServer.concat(this.pathApiStatisctics);
  
  //Retrieve Customers By actions
  pathApiCustomers:string="/v1/actionCustomers";
  urlRequestCustomers: string =urlServer.concat(this.pathApiCustomers);

  constructor(private httpClient:HttpClient) {
    this.newactionSubject=new Subject();
    this.modifyactionSubject=new Subject();
    this.deleteactionSubject=new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
   
   }


  //NEWACTION variables
  pathApi:string="/v1/action";
  newactionSubject:Subject<any>;
  newactionRequest:any;
  urlRequestNewaction: string =urlServer.concat(this.pathApi);

  //Modifyaction variables
  pathApiModifyaction:string="/v1/action/";
  modifyactionSubject:Subject<any>;
  modifyactionRequest:any;
  urlRequestModifyaction: string =urlServer.concat(this.pathApi);

  //DELETEACTION variables
  pathApideleteaction:string="/v1/action/";
  deleteactionSubject:Subject<any>;
  deleteactionRequest:any;
  urlRequestDeleteaction: string =urlServer.concat(this.pathApi);
  getNewaction() {
    
    this.newactionSubject = new Subject();
    const action = {
      action_label: this.newactionRequest.action_label,
      action_type:this.newactionRequest.action_type,
      customer:this.newactionRequest.customer
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestNewaction,action,{headers: header}).subscribe((response: any) => {
        this.newactionSubject.next(response);
        this.newactionSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getModifyaction(id:any) {
    
    this.modifyactionSubject = new Subject();
    const action = {
      action_label: this.modifyactionRequest.action_label,
      action_type:this.modifyactionRequest.action_type,
      customer:this.modifyactionRequest.customer
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.put(this.urlRequestModifyaction+"/"+id,action,{headers: header}).subscribe((response: any) => {
        this.modifyactionSubject.next(response);
        this.modifyactionSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getDeleteaction(id:any) {
    
    this.deleteactionSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.delete(this.urlRequestDeleteaction+"/"+id,{headers: header}).subscribe((response: any) => {
        this.deleteactionSubject.next(response);
        this.deleteactionSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  
  getActionsStatistics(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestStatisctics,{headers: header});
  }

  getCustomersByAction(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestCustomers,{headers: header});
  }

}

